import React from 'react';

function DefaultModal({ show, type, onClose, message }) {
    // Definindo os estilos e textos baseados no tipo
    let title, headerClass, buttonText, buttonColor;
    
    switch(type) {
        case 'error':
            title = 'Atenção!';
            headerClass = 'bg-danger';
            buttonText = 'Fechar';
            buttonColor = 'btn-danger';
            break;
        case 'success':
            title = 'Sucesso!';
            headerClass = 'bg-success';
            buttonText = 'Ok';
            buttonColor = 'btn-success';
            break;
        case 'warning':
            title = 'Aviso';
            headerClass = 'bg-warning';
            buttonText = 'Ok';
            buttonColor = 'btn-warning';
            break;
        case 'information':
            title = 'Informação';
            headerClass = 'bg-info';
            buttonText = 'Entendi';
            buttonColor = 'btn-info';
            break;
        default:
            title = 'Mensagem';
            headerClass = 'bg-primary';
            buttonText = 'Ok';
            buttonColor = 'btn-primary';
    }

    const formatText = (text) => {
        return text.split(/(\*\*.+?\*\*|\*.+?\*|_.+?_|~~.+?~~)/g).map((part, i) => {
            if (part.startsWith('**') && part.endsWith('**')) {
                return <strong key={i}>{part.slice(2, -2)}</strong>;
            }
            if (part.startsWith('*') && part.endsWith('*')) {
                return <em key={i}>{part.slice(1, -1)}</em>;
            }
            if (part.startsWith('_') && part.endsWith('_')) {
                return <u key={i}>{part.slice(1, -1)}</u>;
            }
            if (part.startsWith('~~') && part.endsWith('~~')) {
                return <del key={i}>{part.slice(2, -2)}</del>;
            }
            return part;
        });
    };

    const renderMessage = () => {
        return message.split('\n').map((line, index) => (
            <React.Fragment key={index}>
                {formatText(line)}
                {index < message.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <div 
            className={`modal fade ${show ? 'show d-block' : 'd-none'}`} 
            tabIndex="-1" 
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            onClick={onClose} // Fecha ao clicar fora do modal
        >
            <div className="modal-dialog" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className={`modal-header ${headerClass} py-1`}>
                        <h6 className="modal-title text-center text-white m-0 small">{title}</h6>
                        <button
                          className="btn btn-link text-white p-0 mb-0"
                          onClick={onClose}
                          title="Fechar"
                          style={{ fontSize: '0.9rem', textDecoration: 'none' }}
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-0">{renderMessage()}</p>
                    </div>
                    <div className="modal-footer py-1">
                        <button 
                            type="button" 
                            className={`btn ${buttonColor} py-1 px-3`} 
                            onClick={onClose}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DefaultModal;